import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { EventTypes, PageSource } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import { Course, GrowthCategory } from '@mc/api'

import BusinessBanner from 'components/BusinessBanner/BusinessBanner'
import { ClassSampleEmailCapture } from 'components/EmailCapture'
import { FAQ } from 'components/FAQ'
import { Subscription } from 'components/Subscription'

import { useScrollToUrlFragment, useSubcategoryPageEvents } from '../../utils'
import { ArticleCarousel } from '../ArticleCarousel'
import { InstructorCarousel } from '../InstructorCarousel'
import { OutcomeCarousel } from '../OutcomeCarousel'
import { OtherCoursesCarousel } from '../OtherCoursesCarousel'

export const BelowTheFold = () => {
  const { t } = useTranslation('@mc/next')
  const { primaryCategoryCourses, primaryCategory, outcomeRanking } =
    useStaticData<{
      primaryCategoryCourses: Course[]
      primaryCategory: GrowthCategory
      outcomeRanking: string[]
    }>()

  useScrollToUrlFragment()
  const { getPageCategoryInfo, trackComponentViewed } =
    useSubcategoryPageEvents()

  return (
    <>
      {outcomeRanking.map((outcomeSlug, idx) => {
        if (idx === 0) return null
        return (
          <OutcomeCarousel
            key={outcomeSlug}
            outcomeSlug={outcomeSlug}
            rowIndex={idx}
          />
        )
      })}

      <TrackingContainer
        onFirstVisible={() => trackComponentViewed('meet_your_instructors')}
      >
        <InstructorCarousel />
      </TrackingContainer>

      <TrackingContainer
        onFirstVisible={() => trackComponentViewed('whats_included')}
      >
        <Subscription eventProps={getPageCategoryInfo()} />
      </TrackingContainer>

      <TrackingContainer
        onFirstVisible={() => trackComponentViewed('related_articles')}
      >
        <ArticleCarousel />
      </TrackingContainer>

      <TrackingContainer
        onFirstVisible={() => trackComponentViewed('other_classes')}
      >
        <OtherCoursesCarousel
          className='container mc-mst-12 mc-py-10'
          carouselSlug={primaryCategory.slug}
          courses={primaryCategoryCourses}
          title={t('course.relatedCourses.category.title', {
            category: primaryCategory.name,
          })}
        />
      </TrackingContainer>

      <ClassSampleEmailCapture
        trackProps={{
          trackLocation: 'subcategory_page_body_slim_banner',
          contentType: 'home',
        }}
      />
      <TrackingContainer onFirstVisible={() => trackComponentViewed('faq')}>
        <FAQ
          className='container mc-my-12'
          eventType={EventTypes.SUBCATEGORY_PAGE_CLICK}
          pageSource={PageSource.SUBCATEGORY}
          eventLocation='faq-section'
          sections={['bogo', 'promo', 'general', 'pricing', 'sessions']}
        />
      </TrackingContainer>

      <BusinessBanner pageSource={PageSource.SUBCATEGORY} />
    </>
  )
}
